module.exports = __webpack_public_path__ + "img/SSWS_Big_sword.3a9681bf.png";